import Component from "./component";
import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmNumberBox, mmNumberBoxOptions } from "@/types";
import { prefix } from "./constants";
import { name } from "eslint-plugin-prettier/recommended";

class NumberBox extends Component<mmNumberBoxOptions> implements mmNumberBox {
  private _dxNumberBox!: DevExpress.ui.dxNumberBox;

  constructor(element: HTMLElement, options?: mmNumberBoxOptions) {
    super(element, options);

    this._dxNumberBox = ($(this._element) as any)
      .dxNumberBox({
        accessKey: this._options.accessKey,
        activeStateEnabled: this._options.activeStateEnabled,
        disabled: this._options.disabled,
        readOnly: this._options.readOnly,
        elementAttr: {
          class: generateClassName(
            "number-box",
            this._options.color!,
            this._options.size!,
            this._options.shape,
            this._options.className,
          ),
          ...(this._options.attributes ?? {}),
        },
        inputAttr: this._options.inputAttr,
        height: this._options.height,
        hint: this._options.hint,
        hoverStateEnabled: this._options.hoverStateEnabled,
        rtlEnabled: this._options.rtlEnabled,
        tabIndex: this._options.tabIndex,
        visible: this._options.visible,
        width: this._options.width,

        value: this._options.value ?? undefined,
        isValid: true,
        validationStatus: "valid",
        invalidValueMessage: "Value must be a number",
        name: this._options.name,
        min: this._options.min,
        max: this._options.max,
        step: this._options.step,
        valueChangeEvent: this._options.valueChangeEvent,
        isDirty: this._options.isDirty,
        validationError: this._options.validationError,
        validationErrors: this._options.validationErrors,
        validationMessageMode: this._options.validationMessageMode,
        validationMessagePosition: this._options.validationMessagePosition,

        placeholder: this._options.placeholder,
        label: this._options.label,
        labelMode: this._options.labelMode,
        stylingMode: this._options.style ?? this._options.stylingMode,
        buttons: this._options.buttons,
        showSpinButtons: this._options.showSpinButtons,
        useLargeSpinButtons: this._options.useLargeSpinButtons,
        showClearButton: this._options.showClearButton,

        format: this._options.format,
        mask: this._options.mask,
        maskChar: this._options.maskChar,
        maskInvalidMessage: this._options.maskInvalidMessage,
        maskPlaceholder: this._options.maskPlaceholder,
        showMaskMode: this._options.showMaskMode,
        useMaskedValue: this._options.useMaskedValue,

        onChange: this._options.onChange,
        onContentReady: this._options.onContentReady,
        onCopy: this._options.onCopy,
        onCut: this._options.onCut,
        onDisposing: this._options.onDisposing,
        onEnterKey: this._options.onEnterKey,
        onFocusIn: this._options.onFocusIn,
        onFocusOut: this._options.onFocusOut,
        onInitialized: this._options.onInitialized,
        onInput: this._options.onInput,
        onKeyDown: this._options.onKeyDown,
        onKeyUp: this._options.onKeyUp,
        onOptionChanged: this._options.onOptionChanged,
        onPaste: this._options.onPaste,
        onValueChanged: this._options.onValueChanged,
      })
      .dxNumberBox("instance");
  }

  public get value(): number | undefined {
    return this._dxNumberBox.option("value"); // undefined ise boş, 0 ise geçerli
  }

  public set value(val: number | undefined) {
    this._dxNumberBox.option("value", val);
  }

  public get readOnly(): boolean {
    const val = this._dxNumberBox.option("readOnly");
    return val !== undefined ? val : false;
  }
  public set readOnly(val: boolean) {
    this._dxNumberBox.option("readOnly", val);
  }

  public get disabled(): boolean {
    const val = this._dxNumberBox.option("disabled");
    return val !== undefined ? val : false;
  }
  public set disabled(val: boolean) {
    this._dxNumberBox.option("disabled", val);
  }

  public get isEmpty(): boolean {
    const val = this._dxNumberBox.option("value") as number | undefined | null;
    return val === undefined || val === null || isNaN(val);
  }

  public set isEmpty(val: boolean) {
    if (val) {
      this._dxNumberBox.option("value", undefined);
    }
  }

  public get mask(): string | undefined {
    return this._dxNumberBox.option("mask");
  }
  public set mask(val: string | undefined) {
    this._dxNumberBox.option("mask", val);
  }

  public getDefaults(): Partial<mmNumberBoxOptions> {
    return {
      value: 0,
      readOnly: false,
      disabled: false,
      hoverStateEnabled: true,
      color: "default",
      size: "md",
      step:1,
      width: "100%",
      showSpinButtons:false,
      shape: "normal",
      valueChangeEvent: "change",
      rtlEnabled: false,
      visible: true,
    };
  }
}

registerComponent("mmNumberBox", NumberBox);

export default NumberBox;
